import React from "react";

export const PageHero = ({ title, subtitle, image }) => (
  <header
    className="page-hero"
    style={{ backgroundImage: `linear-gradient(rgba(24,22,20,0.55), rgba(24,22,20,0.65)), url(${image})` }}
  >
    <div className="container">
      <h1>{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
  </header>
);
